import { Component } from "@angular/core";

@Component({
  selector: "app-icon-chevron-up",
  standalone: true,
  imports: [],
  templateUrl: "./chevron-up.component.html",
})
export class ChevronUpIconComponent {}
